export class FetchError extends Error {
    method;
    url;
    details;
    constructor(params) {
        super();
        this.method = params.method;
        this.url = params.url;
        this.details = params.details;
        this.message = this.buildMessage();
    }
    buildMessage() {
        const baseMessage = this.message || 'Fetch error ocurred.';
        return `[${this.method} ${this.url.toString()}] [${this.constructor.name}] ${baseMessage} Error details: ${JSON.stringify(this.details)}`;
    }
}
export class HttpResponseError extends FetchError {
    success;
    statusCode;
    constructor(params) {
        super({
            ...params,
            details: { ...params.details, errorBody: params.errorBody },
        });
        this.success = false;
        this.statusCode = params.statusCode;
    }
}
export class HttpClientError // 400-499
// 400-499
 extends HttpResponseError {
}
export class BadRequestError // 400
// 400
 extends HttpResponseError {
    statusCode = 400;
    errors;
    unhandledErrors;
    constructor(params) {
        super(params);
        const validationError = params.errorBody;
        this.errors = validationError.errors ?? [];
        if (validationError.unhandledErrors) {
            this.unhandledErrors = validationError.unhandledErrors;
        }
    }
}
/**
 * User only for Daemon rest communication
 */
export class RestRequestError // 400
// 400
 extends HttpResponseError {
    statusCode = 400;
    constructor(params) {
        super(params);
    }
}
export class UnauthorizedError //401
//401
 extends HttpResponseError {
    statusCode = 401;
}
export class ForbiddenError //403
//403
 extends HttpResponseError {
    statusCode = 403;
}
export class NotFoundError //404
//404
 extends HttpResponseError {
    statusCode = 404;
}
export class ConflictError //409
//409
 extends HttpResponseError {
    statusCode = 409;
}
export class TooManyRequestsError //429
//429
 extends HttpResponseError {
    statusCode = 429;
    retryAfter;
    constructor(params) {
        super(params);
        this.retryAfter = params.retryAfter;
    }
}
export class HttpServerError //500 - 599
//500 - 599
 extends HttpResponseError {
}
export class ServiceUnavailableError //502, 503, 504
//502, 503, 504
 extends HttpServerError {
}
/**
 * Errors not coming from the Http server
 */
export class NoResponseFetchError extends FetchError {
}
export class NetworkConnectionError extends NoResponseFetchError {
}
export class NetworkCancellationError extends NoResponseFetchError {
}
export class FetcherConfigurationError extends NoResponseFetchError {
}
